export default __webpack_public_path__ + "static/media/image_linux.a9e6daf5.svg";